import { isValidPrice, isValidBasePrice } from '@acme/b2b/pricing';
import { BasePriceIfNumberFilterModule, CurrencyIfNumberFilterModule } from '@b2b/common/filters';
import { NoticesComponentModule } from '@b2b/common/components/notices';
import { FactoryFormsModule } from '@b2b/common/factories/forms/forms.factory';
import { NoticeFactory } from '@b2b/common/factories/notice';
import { ApiService } from '@b2b/common/services/api/types';
import { PermissionsService } from '@b2b/common/services/permissions';
import { ThemesHelperService } from '@b2b/common/services/themesHelper';
import { ensureArray } from '@b2b/common/utils/coerce-array';
import { ColumnDef, TODO, UIBModalService } from '@b2b/types/core';
import uiRouter, { StateService } from '@uirouter/angularjs';
import angular, { IFilterService, IScope, ITimeoutService } from 'angular';

export const ProgramsInstanceEditControllerModule = angular
  .module('acme.view.application.programs.instance.edit.controllers', [
    uiRouter,
    'ui.bootstrap',
    'acme.common.service.api',
    'acme.common.service.helpers',
    'acme.common.service.templates',
    'acme.common.service.templates.helpers',
    'acme.common.service.validate',
    'acme.common.service.calendar',
    'acme.common.service.permissions',
    'acme.common.factory.notice',
    'acme.common.factory.relink',
    FactoryFormsModule,
    'acme.common.service.userPreferences',
    'acme.view.application.programs.instance.edit.removeModal.controllers',
    'acme.view.application.programs.instance.edit.cancelModal.controllers',
    'acme.view.application.programs.instance.edit.resources.controllers',
    'acme.view.application.programs.modals.scheduleChangedModal.controllers',
    'acme.view.application.programs.modals.confirmUpdateEvent.controllers',
    'acme.view.application.programs.modals.cannotRelink.controllers',
    'acme.common.service.ticketConfig',
    'acme.common.service.themesHelper',
    NoticesComponentModule,
    BasePriceIfNumberFilterModule,
    CurrencyIfNumberFilterModule,
  ])
  .controller('ProgramsInstanceEditController', [
    '$scope',
    '$state',
    '$uibModal',
    '$timeout',
    '$filter',
    'ApiService',
    'ValidateService',
    'HelpersService',
    'CalendarService',
    'TemplatesService',
    'TemplatesHelpersService',
    'NoticeFactory',
    'RelinkFactory',
    'FormsFactory',
    'UserPreferencesService',
    'TicketConfigService',
    'PrinterData',
    'PermissionsService',
    'ThemesHelperService',
    function ProgramsInstanceEditController(
      $scope: IScope & { programsInstanceEdit: TODO; programsInstanceEditGrid: TODO; addOnGridOptions: TODO },
      $state: StateService,
      $uibModal: UIBModalService,
      $timeout: ITimeoutService,
      $filter: IFilterService,
      ApiService: ApiService,
      ValidateService: TODO,
      HelpersService: TODO,
      CalendarService: TODO,
      TemplatesService: TODO,
      TemplatesHelpersService: TODO,
      NoticeFactory: NoticeFactory,
      RelinkFactory: TODO,
      FormsFactory: TODO,
      UserPreferencesService: TODO,
      TicketConfigService: TODO,
      PrinterData: TODO,
      PermissionsService: PermissionsService,
      ThemesHelperService: ThemesHelperService
    ) {
      const flexPayWatchers: TODO[] = [];

      const ctrl = {
        model: {} as TODO,

        modalDialog: {} as TODO,

        isLoaded: false,
        isSaving: false,
        isSubmitted: false,
        isCancelled: false,

        emailSetting: 'always',
        company: ThemesHelperService.getCompany() as TODO,

        showTimeModal: false,

        notice: new NoticeFactory(),
        relink: new RelinkFactory(),
        shortDescriptionMax: 300,

        priceLists: [] as TODO[],
        originalPriceList: {} as TODO,
        currentPriceList: {} as TODO,

        selectedInventory: {} as TODO,

        currentEventName: '',

        ticketConfigs: [] as TODO[],
        originalTicketConfig: {} as TODO,
        currentTicketConfig: {} as TODO,
        currentTicketConfigId: '',
        tenantTicketConfig: {} as TODO,
        printers: [] as TODO[],
        hasEnabledPrinters: false,

        endDate: null as TODO,
        startDate: null as TODO,

        formattedCancellationDate: '',
        formattedLastModified: '',

        layoutLevels: TicketConfigService.getLayout('events'),

        addons: [] as TODO[],
        selectedAddon: {} as TODO,

        editor: {} as TODO,
        orderForm: false as TODO,
        preferences: new FormsFactory().getDefaultObjectPreferences(),

        fullCustomFields: [] as TODO,

        currentTab: 'description',

        discountCodes: [] as TODO[],
        tabErrors: {
          description: false,
          schedule: false,
          pricing: false,
          flexpay: false,
          resources: false,
          tickets: false,
          forms: false,
          addons: false,
        },

        flexpayTypes: TemplatesHelpersService.getFlexpayTypes(),
        getFlexpayType: TemplatesHelpersService.getFlexpayType,
        timeStampDateFormat: UserPreferencesService.getDateFormat('standardDateTime', 'dateFormat'),
        timeStampHourFormat: UserPreferencesService.getDateFormat('standardTime', 'hourFormat'),

        summernoteConfig: {
          height: 300,
          focus: true,
          shortcuts: false,
          toolbar: [
            ['style', ['bold', 'italic', 'underline', 'clear']],
            ['fontsize', ['fontsize']],
            ['color', ['color']],
            ['para', ['ul', 'ol', 'paragraph']],
            ['height', ['height']],
          ],
        },

        isSuspended: false,

        columns: [
          {
            field: 'personType.displayOrder',
            displayName: 'Order',
            visible: false,
          },
          {
            field: 'personType.name',
            displayName: 'Ticket Type',
            cellClass: 'col-inactive',
          },
          {
            field: 'personType.description',
            displayName: 'Description',
            cellClass: 'col-inactive',
          },
          {
            field: 'personType.active',
            displayName: 'Status',
            cellTemplate: `<div class="ui-grid-cell-contents"><span data-ng-if="COL_FIELD">Live</span><span data-ng-if="!COL_FIELD">Deactivated</span></div>`,
            cellClass: 'col-inactive',
          },
          {
            field: 'price',
            displayName: 'Price',
            cellFilter: 'currencyIfNumber',
            editableCellTemplate: 'common/includes/cellEditorTemplate.tpl.html',
            enableCellEdit: true,
            enableCellEditOnFocus: true,
          },
          {
            field: 'salesChannels[0].enabled',
            displayName: 'Web',
            cellTemplate: `<div data-ng-class="\'colt\' + col.index"><label><input type="checkbox" class="grid-input" data-ng-model="MODEL_COL_FIELD" /><span class="sr-only">Web</span></label></div>`,
          },
          {
            field: 'salesChannels[1].enabled',
            displayName: 'POS',
            cellTemplate: `<div data-ng-class="\'colt\' + col.index"><label><input type="checkbox" class="grid-input" data-ng-model="MODEL_COL_FIELD" /><span class="sr-only">POS</span></label></div>`,
          },
          {
            field: 'salesChannels[2].enabled',
            displayName: 'Reseller',
            cellTemplate: `<div data-ng-class="\'colt\' + col.index"><label><input type="checkbox" data-ng-disabled="templatesCreatePricing.model.memberOnlyEvent" class="grid-input" data-ng-model="MODEL_COL_FIELD" /><span class="sr-only">Reseller</span></label></div>`,
            visible: true,
          },
          {
            field: 'salesChannels[3].enabled',
            displayName: 'Customer Rep.',
            cellTemplate: `<div data-ng-class="\'colt\' + col.index"><label><input type="checkbox" class="grid-input" data-ng-model="MODEL_COL_FIELD" /><span class="sr-only">Customer Rep.</span></label></div>`,
            visible: true,
          },
          {
            field: 'salesChannels[5].enabled',
            displayName: 'Kiosk',
            cellTemplate: `<div data-ng-class="\'colt\' + col.index"><label><input type="checkbox" class="grid-input" data-ng-model="MODEL_COL_FIELD" /><span class="sr-only">Kiosk</span></label></div>`,
            visible: true,
          },
          {
            field: 'remove',
            displayName: 'Action',
            onCellNavClick: function (row, col) {
              $scope.programsInstanceEdit.remove(row);
            },
            cellTemplate: `<div class="ui-grid-cell-contents" ng-class="col.colIndex()"><a data-ng-click="grid.appScope.remove(row)">Remove<span class="sr-only">-Opens a dialog</span></a></div>`,
          },
        ] as ColumnDef[],

        enableSalesTax: false,

        init: function () {
          ctrl.enableSalesTax = ThemesHelperService.getFeatureFlag('enableSalesTax');

          if (ctrl.enableSalesTax) {
            const priceColumnIndex = ctrl.columns.findIndex((column) => column.field === 'price');

            /**
             * Insert after `basePrice` after `price` column
             */
            ctrl.columns.splice(priceColumnIndex + 1, 0, {
              field: 'basePrice',
              displayName: 'Base Price',
              cellFilter: 'basePriceIfNumber',
              editableCellTemplate: 'common/includes/cellEditorTemplate.tpl.html',
              enableCellEdit: true,
              enableCellEditOnFocus: true,
            });
          }

          ctrl.getEvent($state.params.id);
          ctrl.getDiscountCodes();
          ctrl.getPriceLists();
          ctrl.getTicketConfigs();
          ctrl.getDefaultTicketConfig();
          ctrl.getAddons();
          ctrl.getNotificationPreference();
        },

        updateHeader: function () {
          $scope.$emit('Application::contentTitleChange', {
            title: 'Edit ' + (ctrl.model.type && ctrl.model.type === 'private' ? 'Private ' : '') + 'Event',
            buttonLeft: {
              label: 'Cancel',
              action: function () {
                $scope.programsInstanceEdit.cancel();
              },
            },
            buttonRight: {
              permissions: 'EVENT_UPDATE',
              label: 'Update',
              action: function () {
                $scope.programsInstanceEdit.complete();
              },
            },
          });
        },

        getNotificationPreference: function () {
          if (ctrl.company.hasOwnProperty('notificationPreference')) {
            ctrl.emailSetting = ctrl.company.notificationPreference;
          }
        },

        sync: function () {
          if (ctrl.isSuspended) {
            const suspendedModal = $uibModal.open({
              templateUrl: 'views/application/views/programs/modals/cannotRelink/cannotRelink.tpl.html',
              size: 'md',
              controller: 'ProgramsModalsCannotRelinkController',
            });

            suspendedModal.result.then((data) => {
              ctrl.processSync();
            });
          } else {
            ctrl.processSync();
          }
        },

        processSync: function () {
          const fields = [
            { name: 'name', originalFields: true },
            { name: 'capacity', originalFields: true },
            { name: 'flexPays', originalFields: true },
            { name: 'description', originalFields: false },
            { name: 'shortDescription', originalFields: false },
            { name: 'emailConfirmationMessage', originalFields: false },
            { name: 'emailCancellationMessage', originalFields: false },
            { name: 'customFields', originalFields: false },
            { name: 'ticketConfig', originalFields: false },
            { name: 'ticketDetails', originalFields: false },
            { name: 'salesChannels', originalFields: true },
          ];

          for (let i = 0, ii = fields.length; i < ii; i++) {
            if (ctrl.model.fieldStatus[fields[i].name].modified) {
              ctrl.link(fields[i].name, fields[i].originalFields);
              ctrl.model.fieldStatus[fields[i].name].modified = false;
            }
          }

          ctrl.linkPricing();
          ctrl.model.fieldStatus['priceList'].modified = false;

          if (!ctrl.isSuspended) {
            ctrl.linkTime('start');
            ctrl.model.fieldStatus['startTime'].modified = false;

            ctrl.linkTime('end');
            ctrl.model.fieldStatus['endTime'].modified = false;
          }

          ctrl.linkTicketConfig();
          ctrl.model.fieldStatus['ticketConfig'].modified = false;

          ctrl.linkTicketDetails();
          ctrl.model.fieldStatus['ticketDetails'].modified = false;
        },

        linkCustomFields: function () {
          ctrl.link('customFields', false);

          $timeout(() => {
            if (ctrl.model.customFields instanceof Array && ctrl.model.customFields.length) {
              angular.forEach(ctrl.model.customFields, (item, index) => {
                ctrl.fullCustomFields[index].value = item.value;
              });
            } else {
              angular.forEach(ctrl.fullCustomFields, (item, index) => {
                item.value = '';
              });
            }
          }, 0);
        },

        linkPricing: function () {
          ctrl.link('priceList', true);
          // next tick
          $timeout(() => {
            ctrl.currentPriceList = angular.copy(ctrl.model.priceList);
          }, 0);
        },

        unlinkPricing: function () {
          ctrl.unlink('priceList', true);
        },

        linkTicketConfig: function () {
          ctrl.link('ticketConfig', true);
          // next tick
          $timeout(() => {
            ctrl.currentTicketConfig = angular.copy(ctrl.model.ticketConfig);
            if (
              ctrl.currentTicketConfig &&
              ctrl.currentTicketConfig.printerConfigs instanceof Array &&
              ctrl.currentTicketConfig.printerConfigs.length
            ) {
              for (let i = 0, ii = ctrl.currentTicketConfig.printerConfigs.length; i < ii; i++) {
                // ensure that all printers set to schedule since we are relinking.
                ctrl.currentTicketConfig.printerConfigs[i].selection = ctrl.layoutLevels[0].value;
              }
            }
            ctrl.setPrinterConfig(ctrl.printers);
          }, 0);
        },

        unlinkTicketConfig: function () {
          ctrl.unlink('ticketConfig', true);
        },

        linkTime: function (type) {
          ctrl.link(type + 'Time', true);
          ctrl[type + 'Date'] = CalendarService.parseDate(ctrl.model[type + 'Time']);
        },

        unlinkTime: function (type) {
          ctrl.unlink(type + 'Time', true);
        },

        linkFlexPays: function (field, index) {
          ctrl.model.flexPays[index][field] = ctrl.relink.linkArray('flexPays', field, index, true);
        },

        unlinkFlexPays: function (field, index) {
          ctrl.model.flexPays[index][field] = ctrl.relink.unlinkArray('flexPays', field, index, true);
        },

        linkFlexPaysType: function (index) {
          ctrl.linkFlexPays('type', index);
          ctrl.linkFlexPays('discountId', index);
        },

        unlinkFlexPaysType: function (index) {
          ctrl.unlinkFlexPays('type', index);
          ctrl.unlinkFlexPays('discountId', index);
        },

        linkFlexPaysTime: function (index) {
          ctrl.linkFlexPays('startTime', index);
          ctrl.linkFlexPays('endTime', index);
        },

        unlinkFlexPaysTime: function (index) {
          ctrl.unlinkFlexPays('startTime', index);
          ctrl.unlinkFlexPays('endTime', index);
        },

        linkTicketDetails: function () {
          ctrl.model.ticketDetails = ctrl.relink.link('ticketDetails', true);
        },

        unlinkTicketExpiration: function () {
          ctrl.model.ticketDetails = ctrl.relink.unlink('ticketDetails', true);
        },

        link: function (field, useOriginalFields) {
          if (field && field === 'priceList') {
            ctrl.model[field] = ctrl.relink.linkPriceList(field, useOriginalFields);
          } else {
            ctrl.model[field] = ctrl.relink.link(field, useOriginalFields);
          }
        },

        unlink: function (field, useOriginalFields) {
          ctrl.model[field] = ctrl.relink.unlink(field, useOriginalFields);
        },

        getEvent: function (id) {
          if (id) {
            ApiService.program.instances
              .detail(id)
              .then((response) => {
                ctrl.success.getEvent(response);
              })
              .catch((response) => {
                ctrl.error.getEvent(response);
              });
          } else {
            ctrl.error.getEvent({});
          }
        },

        getPublishedEventTemplate: function (id) {
          if (id) {
            ApiService.program.template
              .published({ eventTemplateId: id })
              .then(ctrl.success.getPublishedEventTemplate)
              .catch(ctrl.error.getPublishedEventTemplate);
          }
        },

        getDiscountCodes: function () {
          ApiService.discounts
            .list('v2', HelpersService.getPaginator())
            .then(ctrl.success.getDiscountCodes)
            .catch(ctrl.error.getDiscountCodes);
        },

        getPriceLists: function () {
          ApiService.price.lists
            .list(HelpersService.getPaginator())
            .then(ctrl.success.getPriceLists)
            .catch(ctrl.error.getPriceLists);
        },

        getTicketConfigs: function () {
          ApiService.tickets
            .list(HelpersService.getPaginator())
            .then(ctrl.success.getTicketConfigs)
            .catch(ctrl.error.getTicketConfigs);
        },

        getDefaultTicketConfig: function () {
          ApiService.themes
            .getTicketConfig()
            .then(ctrl.success.getDefaultTicketConfig)
            .catch(ctrl.error.getDefaultTicketConfig);
        },

        getAddons: function () {
          ApiService.inventory
            .list(HelpersService.getPaginator())
            .then(ctrl.success.getAddons)
            .catch(ctrl.error.getAddons);
        },

        hasPrices: function () {
          return ctrl.currentPriceList.prices instanceof Array && ctrl.currentPriceList.prices.length > 0;
        },

        hasFlexpays: function () {
          return ctrl.model.flexPays instanceof Array && ctrl.model.flexPays.length;
        },

        isLayoutSelection: function (printer, type) {
          return printer && printer.selection && type && printer.selection === type;
        },

        findDiscount: function (id) {
          for (let i = 0, ii = ctrl.discountCodes.length; i < ii; i++) {
            if (ctrl.discountCodes[i].id === id) {
              return ctrl.discountCodes[i];
            }
          }

          return false;
        },

        createFlexpay: function () {
          const endDate = new Date(ctrl.endDate);
          const startDate = new Date(ctrl.startDate);

          return {
            discountId: null,
            name: '',
            endDate: endDate,
            startDate: startDate,
            endTime: CalendarService.toISO8601(endDate),
            startTime: CalendarService.toISO8601(startDate),
            type: 'payWhatYouWish',
          };
        },

        addFlexpay: function () {
          const fp = ctrl.createFlexpay();

          if (!ctrl.model.flexPays || !(ctrl.model.flexPays instanceof Array)) {
            ctrl.model.flexPays = [];
          }

          ctrl.model.flexPays.push(fp);
          //ctrl.model.originalFields.flexPays.push(fp);
          // Update current with new data
          ctrl.relink.setCurrent(ctrl.model);

          const fpi = ctrl.model.flexPays.length - 1;

          flexPayWatchers.push(function (n, o) {
            ctrl.model.fieldStatus['flexPays'].modified = !ctrl.relink.equal('flexPays', true);
          });
          $scope.$on(
            '$destroy',
            $scope.$watchCollection('programsInstanceEdit.model.flexPays[' + fpi + ']', flexPayWatchers[fpi])
          );
        },

        removeFlexpay: function (index) {
          ctrl.model.flexPays.splice(index, 1);
          // Destroy watcher
          flexPayWatchers[index]();
        },

        cancelEvent: function () {
          ctrl.modalDialog = $uibModal.open({
            templateUrl: 'views/application/views/programs/instance/edit/modals/cancelEvent.tpl.html',
            size: 'md',
            controller: 'ProgramsInstanceEditCancelModalController',
            resolve: {
              currentEvent: function () {
                return ctrl.model;
              },
              emailSetting: function () {
                return ctrl.emailSetting;
              },
            },
          });

          // Invoked when modal completes with close(params)
          ctrl.modalDialog.result
            .then((data) => {
              const props = {
                id: ctrl.model.id,
                sendEmail: data.sendEmail || false,
                sendEmailToResources: data.sendEmailToResources || false,
                emailMessage: data.emailMessage || '',
              };

              ctrl.notice.hideSuccessMessages();
              ctrl.notice.hideErrorMessages();

              ApiService.program.cancel.event(props).then(ctrl.success.cancelEvent).catch(ctrl.success.cancelEvent);
            })
            .catch(() => {
              // noop
            });
        },

        removeEvent: function () {
          ctrl.modalDialog = $uibModal.open({
            templateUrl: 'views/application/views/programs/instance/edit/modals/removeEvent.tpl.html',
            size: 'md',
            controller: 'ProgramsInstanceEditRemoveModalController',
            resolve: {
              currentEvent: function () {
                return ctrl.model;
              },
              SoldQuantity: function () {
                return ctrl.model.soldQuantity;
              },
              emailSetting: function () {
                return ctrl.emailSetting;
              },
            },
          });

          // Invoked when modal completes with close(params)
          ctrl.modalDialog.result
            .then((sendEmail) => {
              ctrl.notice.hideSuccessMessages();
              ctrl.notice.hideErrorMessages();

              ApiService.program.instances
                .remove({
                  id: ctrl.model.id,
                  sendEmail: sendEmail,
                })
                .then(ctrl.success.removeEvent)
                .catch(ctrl.success.removeEvent);
            })
            .catch(() => {
              // noop
            });
        },

        remove: function (row) {
          let index = -1;
          console.log('ProgramsInstanceEditController::remove', row.entity);

          for (let i = 0, ii = ctrl.currentPriceList.prices.length; i < ii; i++) {
            if (ctrl.currentPriceList.prices[i].personType.id === row.entity.personType.id) {
              index = i;
              break;
            }
          }

          if (index > -1) {
            ctrl.currentPriceList.prices.splice(index, 1);
            ctrl.onPriceListChange();
          }
        },

        afterCellEdit: function () {
          ctrl.onPriceListChange();
        },

        revert: function () {
          console.log(ctrl.currentPriceList, ctrl.originalPriceList);
          ctrl.currentPriceList = angular.copy(ctrl.originalPriceList);
          ctrl.onPriceListChange();
        },

        revertTicketConfig: function () {
          console.log(ctrl.currentTicketConfig, ctrl.originalTicketConfig);
          ctrl.currentTicketConfig = angular.copy(ctrl.originalTicketConfig);
          ctrl.onTicketConfigChange();
        },

        updateFlexPaysStartTime: function (index) {
          if (ctrl.model.flexPays[index].startDate) {
            if (ctrl.model.flexPays[index].startDate.getTime() > ctrl.model.flexPays[index].endDate.getTime()) {
              ctrl.updateFlexPaysEndTime(index);
            }
            ctrl.model.flexPays[index].formattedStartTime = $filter('date')(
              ctrl.model.flexPays[index].startDate,
              UserPreferencesService.getDateFormat('standarTime', 'hourFormat')
            );
            ctrl.model.flexPays[index].startTime = CalendarService.toISO8601(
              ctrl.model.flexPays[index].startDate,
              true
            );
          }
        },

        updateFlexPaysEndTime: function (index) {
          if (ctrl.model.flexPays[index].endDate) {
            if (ctrl.model.flexPays[index].startDate.getTime() > ctrl.model.flexPays[index].endDate.getTime()) {
              ctrl.model.flexPays[index].endDate = new Date(
                ctrl.model.flexPays[index].startDate.getFullYear(),
                ctrl.model.flexPays[index].startDate.getMonth(),
                ctrl.model.flexPays[index].startDate.getDate(),
                ctrl.model.flexPays[index].startDate.getHours(),
                ctrl.model.flexPays[index].startDate.getMinutes() + 1,
                ctrl.model.flexPays[index].startDate.getSeconds(),
                ctrl.model.flexPays[index].startDate.getMilliseconds()
              );
            }
            ctrl.model.flexPays[index].formattedEndTime = $filter('date')(
              ctrl.model.flexPays[index].endDate,
              UserPreferencesService.getDateFormat('standardTime', 'hourFormat')
            );
            ctrl.model.flexPays[index].endTime = CalendarService.toISO8601(ctrl.model.flexPays[index].endDate, true);
          }
        },

        updateStartTime: function () {
          if (ctrl.startDate) {
            if (ctrl.startDate.getTime() > ctrl.endDate.getTime()) {
              ctrl.updateEndTime();
            }
            ctrl.model.startDate = $filter('date')(
              ctrl.startDate,
              UserPreferencesService.getDateFormat('extendedDate', 'dateFormat')
            );
            ctrl.model.formattedStartTime = $filter('date')(
              ctrl.startDate,
              UserPreferencesService.getDateFormat('standardTime', 'hourFormat')
            );
            ctrl.model.startTime = CalendarService.toISO8601(ctrl.startDate, true);
            ctrl.model.fieldStatus.startTime.modified = !ctrl.relink.equal('startTime', true);
            ctrl.showTimeModal = true;
          }
        },

        updateEndTime: function () {
          if (ctrl.endDate) {
            if (ctrl.startDate.getTime() > ctrl.endDate.getTime()) {
              ctrl.endDate = new Date(
                ctrl.startDate.getFullYear(),
                ctrl.startDate.getMonth(),
                ctrl.startDate.getDate(),
                ctrl.startDate.getHours(),
                ctrl.startDate.getMinutes() + 1,
                ctrl.startDate.getSeconds(),
                ctrl.startDate.getMilliseconds()
              );
            }
            ctrl.model.endDate = $filter('date')(
              ctrl.endDate,
              UserPreferencesService.getDateFormat('standardTime', 'dateFormat')
            );
            ctrl.model.formattedEndTime = $filter('date')(ctrl.endDate, HelpersService.dateFormats.standardTime);
            ctrl.model.endTime = CalendarService.toISO8601(ctrl.endDate, true);
            ctrl.model.fieldStatus.endTime.modified = !ctrl.relink.equal('endTime', true);

            ctrl.showTimeModal = true;
          }
        },

        process: function (model) {
          if (model.priceList) {
            model.priceList.name = null;
            delete model.priceList.name;

            model.priceList.description = null;
            delete model.priceList.description;

            model.priceList.startTime = null;
            delete model.priceList.startTime;
          }

          model.startTime = CalendarService.toISO8601(ctrl.startDate, true);
          model.endTime = CalendarService.toISO8601(ctrl.endDate, true);

          if (model.priceList) {
            for (let i = 0, ii = model.priceList.prices.length; i < ii; i++) {
              model.priceList.prices[i].primePrice = null;
              delete model.priceList.prices[i].primePrice;
            }
          }

          if (model.flexPays instanceof Array) {
            for (let i = 0, ii = model.flexPays.length; i < ii; i++) {
              if (model.flexPays[i].startDate) {
                model.flexPays[i].startTime = CalendarService.toISO8601(model.flexPays[i].startDate, true);
              }
              if (model.flexPays[i].endDate) {
                model.flexPays[i].endTime = CalendarService.toISO8601(model.flexPays[i].endDate, true);
              }

              model.flexPays[i].startDate = null;
              delete model.flexPays[i].startDate;

              model.flexPays[i].endDate = null;
              delete model.flexPays[i].endDate;

              model.flexPays[i].formattedStartTime = null;
              delete model.flexPays[i].formattedStartTime;

              model.flexPays[i].formattedEndTime = null;
              delete model.flexPays[i].formattedEndTime;

              if (model.flexPays[i].type === 'payWhatYouWish') {
                model.flexPays[i].discountId = null;
              }
            }
          }

          if (model.originalFields && model.originalFields.flexPays instanceof Array) {
            for (let i = 0, ii = model.originalFields.flexPays.length; i < ii; i++) {
              if (model.originalFields.flexPays[i]) {
                model.originalFields.flexPays[i].startDate = null;
                delete model.originalFields.flexPays[i].startDate;

                model.originalFields.flexPays[i].endDate = null;
                delete model.originalFields.flexPays[i].endDate;

                model.originalFields.flexPays[i].formattedStartTime = null;
                delete model.originalFields.flexPays[i].formattedStartTime;

                model.originalFields.flexPays[i].formattedEndTime = null;
                delete model.originalFields.flexPays[i].formattedEndTime;

                if (model.originalFields.flexPays[i].type === 'payWhatYouWish') {
                  model.originalFields.flexPays[i].discountId = null;
                }
              }
            }
          }

          model.ticketConfig = ctrl.marshall();

          return model;
        },

        marshall: function () {
          const model: TODO = {};
          const data: TODO[] = [];
          let r = null;

          if (ctrl.currentTicketConfig) {
            for (let i = 0, ii = ctrl.printers.length; i < ii; i++) {
              // Send empty string to backend if it's not custom
              let config = '';
              const name = ctrl.printers[i].name;

              if (ctrl.isLayoutSelection(ctrl.printers[i], 'custom') && ctrl.printers[i].config) {
                config = ctrl.printers[i].config;
              }
              data.push({
                printerId: ctrl.printers[i].printerId,
                name: name,
                config: config,
                selection: ctrl.printers[i].selection || ctrl.layoutLevels[0].value,
              });
            }

            if (ctrl.currentTicketConfig && ctrl.currentTicketConfig.id) {
              model.id = ctrl.currentTicketConfig.id;
            }
            model.printerConfigs = data;

            r = angular.extend(ctrl.currentTicketConfig || {}, model);
          }

          return r;
        },

        hasValidPrices: function () {
          const prices = ensureArray(ctrl.model.priceList?.prices);

          return prices.every((item) => {
            return isValidPrice(item.price);
          });
        },

        hasValidBasePrices: function () {
          const prices = ensureArray(ctrl.model.priceList?.prices);

          return prices.every((item) => {
            return isValidBasePrice({ basePrice: item.basePrice ?? null, price: item.price });
          });
        },

        complete: function () {
          ctrl.isSubmitted = true;
          ctrl.isSaving = true;
          ctrl.notice.hideErrorMessages();
          ctrl.notice.hideSuccessMessages();

          if (!ctrl.hasValidPrices()) {
            ctrl.isSaving = false;
            ctrl.notice.showErrorMessages([{ message: 'Please enter a valid price' }]);
            return;            
          }

          if (!ctrl.hasValidBasePrices()) {
            ctrl.isSaving = false;
            ctrl.notice.showErrorMessages([{ message: 'Please enter a valid base price' }]);
            return;
          }

          const isValid = ValidateService.validate([
            { len: { value: ctrl.model.name } },
            { len: { value: HelpersService.strip(ctrl.model.description).replace(/\s+/g, '') } },
            {
              greater: {
                greater: ctrl.model.capacity,
                less: 0,
              },
            },
            {
              greater: {
                greater: ctrl.model.ticketDetails.ticketDurationDays,
                less: -1,
              },
            },
            {
              or: {
                values: [
                  ctrl.model.offSchedule &&
                    ctrl.currentPriceList &&
                    ctrl.currentPriceList.prices &&
                    ctrl.currentPriceList.prices.length > 0,
                  !ctrl.model.offSchedule &&
                    ((ctrl.currentPriceList &&
                      ctrl.currentPriceList.prices &&
                      ctrl.currentPriceList.prices.length > 0) ||
                      (ctrl.originalPriceList &&
                        ctrl.originalPriceList.prices &&
                        ctrl.originalPriceList.prices.length > 0)),
                ],
                expected: true,
              },
            },
          ]);

          if (!isValid) {
            ctrl.isSaving = false;
            $scope.programsInstanceEdit.notice.showErrorMessages([{ message: 'Please correct the errors below' }]);
            return;
          }

          ctrl.model.priceList = angular.copy(ctrl.currentPriceList);
          ctrl.model.ticketConfig = angular.copy(ctrl.currentTicketConfig);
          if (ctrl.hasOrderForms()) {
            if (!ctrl.model.orderForms[0].preferences) {
              ctrl.model.orderForms[0].preferences = new FormsFactory().getDefaultNamedPreferences();
            }
            ctrl.model.orderForms[0].preferences.b2c = new FormsFactory().updatePreferences(
              'b2c',
              ctrl.preferences.b2c
            ).b2c;
            ctrl.model.orderForms[0].preferences.pos = new FormsFactory().updatePreferences(
              'pos',
              ctrl.preferences.pos
            ).pos;
            ctrl.model.orderForms[0].preferences.insideSales = new FormsFactory().updatePreferences(
              'insideSales',
              ctrl.preferences.insideSales
            ).insideSales;
            ctrl.model.orderForms[0].preferences.kiosk = new FormsFactory().updatePreferences(
              'kiosk',
              ctrl.preferences.kiosk
            ).kiosk;
          }

          if (ctrl.showTimeModal && ctrl.hasResources()) {
            ctrl.timeModal();
          } else {
            if (ctrl.model.type === 'private') {
              ApiService.program.instances
                .updatePrivate(ctrl.process(angular.copy(ctrl.model)))
                .then(ctrl.success.complete)
                .catch(ctrl.error.complete);
            } else {
              if (ctrl.currentEventName !== ctrl.model.name && ctrl.model.soldQuantity > 0) {
                ctrl.confirmUpdateModal();
              } else {
                ApiService.event
                  .detail(ctrl.model.id)
                  .then((response) => {
                    // search for event summary
                    const event = response.data.payload;
                    ctrl.model.resources = event.resources;
                    ApiService.program.instances
                      .update(ctrl.process(angular.copy(ctrl.model)))
                      .then(ctrl.success.complete)
                      .catch(ctrl.error.complete);
                  })
                  .catch((response) => {
                    console.log(response);
                  });
              }
            }
          }
        },

        hasResources: function () {
          angular.forEach(ctrl.model.resources, function (item, index) {
            if (item.resourceCategory === 'Personnel' && item.resourceName && item.resourceName.length) {
              return true;
            }
          });
          return false;
        },

        timeModal: function () {
          ctrl.modalDialog = $uibModal.open({
            templateUrl: 'views/application/views/programs/modals/scheduleChangedModal/scheduleChangedModal.tpl.html',
            size: 'md',
            controller: 'ProgramsModalsScheduleChangedModalController',
            resolve: {
              currentEvent: function () {
                return ctrl.model;
              },
              emailSetting: function () {
                return ctrl.emailSetting;
              },
            },
          });

          // Invoked when modal completes with close(params)
          ctrl.modalDialog.result.then(
            function (sendEmail) {
              ctrl.showTimeModal = false;
              ctrl.model.sendEmail = sendEmail;
              ApiService.program.instances
                .update(ctrl.process(angular.copy(ctrl.model)))
                .then(ctrl.success.complete)
                .catch(ctrl.error.complete);
            },
            function () {
              // Do nothing
              ctrl.isSaving = false;
            }
          );
        },

        confirmUpdateModal: function () {
          ctrl.modalDialog = $uibModal.open({
            templateUrl: 'views/application/views/programs/modals/confirmUpdateEvent/confirmUpdateEvent.tpl.html',
            size: 'md',
            controller: 'ProgramsModalsConfirmUpdateEventController',
            resolve: {
              SoldQuantity: function () {
                return ctrl.model.soldQuantity;
              },
            },
          });

          ctrl.modalDialog.result
            .then((updateEvent) => {
              if (updateEvent) {
                ApiService.program.instances
                  .update(ctrl.process(angular.copy(ctrl.model)))
                  .then(ctrl.success.complete)
                  .catch(ctrl.error.complete);
              }
            })
            .catch(() => {
              ctrl.isSaving = false;
            });
        },

        cancel: function () {
          window.history.go(-1);
        },

        isTab: function (tab) {
          return tab === ctrl.currentTab;
        },

        getTab: function (tab) {
          ctrl.currentTab = tab;
          ctrl.hasTabErrors(ctrl.currentTab);
        },

        hasOrderForms: function () {
          return ctrl.model.orderForms instanceof Array && ctrl.model.orderForms.length;
        },

        hasTabErrors: function (tab) {
          let r: TODO = false;

          switch (tab) {
            case 'description':
              r = ValidateService.validate([
                { len: { value: HelpersService.strip(ctrl.model.description).replace(/\s+/g, '') } },
                {
                  greater: {
                    greater: ctrl.model.capacity,
                    less: 0,
                  },
                },
              ]);
              ctrl.tabErrors[tab] = r;
              break;
            case 'schedule':
              r = ctrl.startDate && ctrl.endDate;
              ctrl.tabErrors[tab] = r;
              break;
            case 'flexpay':
              r = ctrl.isValidFlexPay();
              ctrl.tabErrors[tab] = r;
              break;
            case 'pricing':
              //either it is an offschedule event, then the currentPriceList must be valid
              //or it is not an offschedule event, then the currentPriceList or the template pricelist must be valid
              r = ValidateService.validate([
                {
                  or: {
                    values: [
                      ctrl.model.offSchedule &&
                        ctrl.currentPriceList &&
                        ctrl.currentPriceList.prices &&
                        ctrl.currentPriceList.prices.length > 0,
                      !ctrl.model.offSchedule &&
                        ((ctrl.currentPriceList &&
                          ctrl.currentPriceList.prices &&
                          ctrl.currentPriceList.prices.length > 0) ||
                          (ctrl.originalPriceList &&
                            ctrl.originalPriceList.prices &&
                            ctrl.originalPriceList.prices.length > 0)),
                    ],
                    expected: true,
                  },
                },
                {
                  greater: {
                    greater: ctrl.model.ticketDetails && ctrl.model.ticketDetails.ticketDurationDays,
                    less: -1,
                  },
                },
              ]);
              ctrl.tabErrors[tab] = r;
              break;
            case 'resources':
              r = true;
              ctrl.tabErrors[tab] = r;
              break;
            case 'tickets':
              r = true;
              ctrl.tabErrors[tab] = r;
              break;
            case 'addons':
              r = true;
              ctrl.tabErrors[tab] = r;
              break;
            case 'forms':
              r = true;
              ctrl.tabErrors[tab] = r;
              break;
          }

          // Checking validity so need to return opposite
          return !r;
        },

        isValidDescription: function () {
          let r = true;

          if (ctrl.isSubmitted) {
            r = ValidateService.validate([
              { len: { value: HelpersService.strip(ctrl.model.description).replace(/\s+/g, '') } },
            ]);
          }

          return r;
        },

        isValidTime: function (value) {
          let r = true;

          if (!value) {
            r = false;
          }

          return r;
        },

        isValidCapacity: function () {
          let r = true;

          if (ctrl.isSubmitted) {
            r = ValidateService.validate([
              {
                greater: {
                  greater: ctrl.model.capacity,
                  less: 0,
                },
              },
            ]);
          }

          return r;
        },

        isValidTicketExpiration: function () {
          let r = true;

          if (ctrl.isSubmitted) {
            r = ValidateService.validate([
              {
                greater: {
                  greater: ctrl.model.ticketDetails.ticketDurationDays,
                  less: -1,
                },
              },
            ]);
          }

          return r;
        },

        isValidTitle: function () {
          let r = true;

          if (ctrl.isSubmitted) {
            r = ValidateService.validate([{ len: { value: ctrl.model.name } }]);
          }

          return r;
        },

        isValidPriceList: function () {
          let r = true;

          if (ctrl.isSubmitted) {
            r = ValidateService.validate([
              {
                or: {
                  values: [
                    ctrl.model.offSchedule &&
                      ctrl.currentPriceList &&
                      ctrl.currentPriceList.prices &&
                      ctrl.currentPriceList.prices.length > 0,
                    !ctrl.model.offSchedule &&
                      ((ctrl.currentPriceList &&
                        ctrl.currentPriceList.prices &&
                        ctrl.currentPriceList.prices.length > 0) ||
                        (ctrl.originalPriceList &&
                          ctrl.originalPriceList.prices &&
                          ctrl.originalPriceList.prices.length > 0)),
                  ],
                  expected: true,
                },
              },
            ]);
          }

          return r;
        },

        isValidTicketConfig: function () {
          let r = true;

          if (ctrl.isSubmitted && ctrl.currentTicketConfig && ctrl.originalTicketConfig) {
            r = ValidateService.validate([
              {
                or: {
                  values: [
                    ctrl.currentTicketConfig.printerConfigs && ctrl.currentTicketConfig.printerConfigs.length > 0,
                    ctrl.originalTicketConfig.printerConfigs && ctrl.originalTicketConfig.printerConfigs.length > 0,
                  ],
                  expected: true,
                },
              },
            ]);
          }

          return r;
        },

        isValidFlexPay: function () {
          let r = true;

          if (ctrl.model.flexPays instanceof Array) {
            for (let i = 0; i < ctrl.model.flexPays.length; i++) {
              if (!ctrl.model.flexPays[i].startDate || !ctrl.model.flexPays[i].endDate) {
                r = false;
                break;
              }
            }
          }
          return r;
        },

        setCurrentPriceList: function () {
          ctrl.priceLists.forEach(function (list) {
            if (list.id === ctrl.currentPriceList.priceListId) {
              const instancePrices = ctrl.currentPriceList.prices;
              const listPrices = list.prices.map((priceItem) => {
                return {
                  personType: priceItem.personType,
                  price: priceItem.price,
                  salesChannels: priceItem.salesChannels,
                };
              });
              if (angular.equals(listPrices, instancePrices)) {
                ctrl.currentPriceList = angular.copy(list);
                // Preserve overridden personType descriptions from the instance
                if (instancePrices) {
                  for (let i = 0; i < ctrl.currentPriceList.prices.length; i++) {
                    if (instancePrices[i]?.personType?.description) {
                      ctrl.currentPriceList.prices[i].personType.description = instancePrices[i].personType.description;
                    }
                  }
                }
              }
            }
          });
        },

        setCurrentTicketConfig: function () {
          if (ctrl.currentTicketConfig && !ctrl.model.fieldStatus.ticketConfig.modified) {
            ctrl.ticketConfigs.forEach(function (ticketConfigItem: TODO) {
              if (ticketConfigItem.id === ctrl.currentTicketConfig.id) {
                ctrl.currentTicketConfig = ticketConfigItem;
              }
            });
          }
        },

        processTicketConfigs: function (list) {
          const r: TODO[] = [];

          for (let i = 0, ii = list.length; i < ii; i++) {
            if (list[i].status && list[i].status.published) {
              r.push(list[i]);
            }
          }

          return r;
        },

        processPrinters: function (list) {
          list = list || [];
          const printersList: TODO[] = [];

          for (let i = 0, ii = list.length; i < ii; i++) {
            if (list[i].printerId && list[i].enabled) {
              printersList.push(list[i]);
            }
          }
          if (printersList.length) {
            ctrl.hasEnabledPrinters = true;
          }
          return printersList;
        },

        setPrinterConfig: function (list) {
          list = list || [];

          for (let i = 0, ii = list.length; i < ii; i++) {
            if (list[i].printerId) {
              const printerConfig: TODO = ctrl.getConfigForPrinter(list[i]);
              list[i].config = printerConfig.config || '';
              list[i].selection = printerConfig.selection || ctrl.layoutLevels[0].value;
            }
          }

          return list;
        },

        getConfigForPrinter: function (printer) {
          if (ctrl.currentTicketConfig && ctrl.currentTicketConfig.id) {
            if (
              ctrl.currentTicketConfig.printerConfigs instanceof Array &&
              ctrl.currentTicketConfig.printerConfigs.length
            ) {
              for (let i = 0, ii = ctrl.currentTicketConfig.printerConfigs.length; i < ii; i++) {
                if (
                  ctrl.currentTicketConfig.printerConfigs[i].printerId &&
                  ctrl.currentTicketConfig.printerConfigs[i].printerId === printer.printerId
                ) {
                  const selection = ctrl.currentTicketConfig.printerConfigs[i].selection || ctrl.layoutLevels[0].value;

                  return {
                    selection: selection,
                    config:
                      selection === ctrl.layoutLevels[2].value ? ctrl.currentTicketConfig.printerConfigs[i].config : '',
                  };
                }
              }
            }
          }

          return '';
        },

        addInventory: function () {
          if (ctrl.selectedInventory.id && !ctrl.findAddon(ctrl.selectedInventory.id)) {
            if (!ctrl.model.addOns.inventoryAddOns) {
              ctrl.model.addOns.inventoryAddOns = [];
            }
            ctrl.selectedInventory.salesChannels = TemplatesService.orderSalesChannels(
              ctrl.selectedInventory.salesChannels
            );
            ctrl.model.addOns.inventoryAddOns.push(angular.copy(ctrl.selectedInventory));
            ctrl.model.addOns.inventoryIds.push(ctrl.selectedInventory.id);
            ctrl.selectedInventory = {};
          }
        },

        findAddon: function (id) {
          if (ctrl.model.addOns.inventoryAddOns instanceof Array && ctrl.model.addOns.inventoryAddOns.length > 0) {
            for (let i = 0, ii = ctrl.model.addOns.inventoryAddOns.length; i < ii; i++) {
              if (ctrl.model.addOns.inventoryAddOns[i].id === id) {
                return ctrl.model.addOns.inventoryAddOns[i];
              }
            }
          }

          return false;
        },

        removeInventory: function (id) {
          for (let i = 0, ii = ctrl.model.addOns.inventoryAddOns.length; i < ii; i++) {
            if (parseInt(ctrl.model.addOns.inventoryAddOns[i].id, 10) === parseInt(id, 10)) {
              ctrl.model.addOns.inventoryAddOns.splice(i, 1);
            }

            if (parseInt(ctrl.model.addOns.inventoryIds[i], 10) === parseInt(id, 10)) {
              ctrl.model.addOns.inventoryIds.splice(i, 1);
            }
          }
        },

        processSalesChannels: function () {
          if (ctrl.model.addOns && ctrl.model.addOns.inventoryAddOns instanceof Array) {
            for (let i = 0, ii = ctrl.model.addOns.inventoryAddOns.length; i < ii; i++) {
              ctrl.model.addOns.inventoryAddOns[i].salesChannels = TemplatesService.orderSalesChannels(
                ctrl.model.addOns.inventoryAddOns[i].salesChannels
              );
            }
          }
        },

        processCustomFields: function () {
          let customFieldsUndefined = false;

          if (ctrl.model.customFields instanceof Array) {
            ctrl.fullCustomFields = angular.copy(ctrl.model.customFields);
          } else {
            customFieldsUndefined = true;
          }

          $scope.$on(
            '$destroy',
            $scope.$watch(
              'programsInstanceEdit.fullCustomFields',
              function (n, o) {
                ctrl.model.customFields = [];
                angular.forEach(ctrl.fullCustomFields, function (item, index) {
                  if (item.value.length) {
                    ctrl.model.customFields.push({
                      name: item.name,
                      value: item.value,
                    });
                  }
                });
                if (!ctrl.model.customFields.length && customFieldsUndefined) {
                  ctrl.model.customFields = null;
                  delete ctrl.model.customFields;
                }
              },
              true
            )
          );
        },

        getScheduleConfigForPrinter: function (printer) {
          if (printer && printer.printerId) {
            const scheduleConfig = ctrl.relink.link('ticketConfig', true);

            if (
              scheduleConfig &&
              scheduleConfig.printerConfigs instanceof Array &&
              scheduleConfig.printerConfigs.length
            ) {
              for (let i = 0, ii = scheduleConfig.printerConfigs.length; i < ii; i++) {
                const printerConfig = scheduleConfig.printerConfigs[i];
                if (printerConfig.printerId && printerConfig.printerId === printer.printerId) {
                  return printerConfig.config || '';
                }
              }
            }
          }

          return '';
        },

        getDefaultConfigForPrinter: function (printer) {
          if (ctrl.tenantTicketConfig && printer && printer.name) {
            for (const printerName in ctrl.tenantTicketConfig) {
              if (ctrl.tenantTicketConfig.hasOwnProperty(printerName) && printerName === printer.name) {
                return ctrl.tenantTicketConfig[printerName] || '';
              }
            }
          }

          return '';
        },

        getSettingsConfigForPrinter: function (printer) {
          if (ctrl.currentTicketConfig && ctrl.currentTicketConfig.id) {
            const ticketConfig = ctrl.findTicketConfig(ctrl.currentTicketConfig.id);

            if (
              ticketConfig &&
              ticketConfig.ticketLayout &&
              ticketConfig.ticketLayout.printerConfigs instanceof Array &&
              ticketConfig.ticketLayout.printerConfigs.length
            ) {
              for (let i = 0, ii = ticketConfig.ticketLayout.printerConfigs.length; i < ii; i++) {
                const printerConfig = ticketConfig.ticketLayout.printerConfigs[i];
                if (printerConfig.printerId && printerConfig.printerId === printer.printerId) {
                  const selection = printerConfig.selection || ctrl.layoutLevels[0].value;

                  if (selection === 'theme') {
                    return ctrl.getDefaultConfigForPrinter(printer);
                  } else {
                    return printerConfig.config || '';
                  }
                }
              }
            }
          }

          return '';
        },

        findTicketConfig: function (id) {
          if (id) {
            for (let i = 0, ii = ctrl.ticketConfigs.length; i < ii; i++) {
              if (ctrl.ticketConfigs[i].id === id) {
                return {
                  index: i,
                  ticketLayout: ctrl.ticketConfigs[i],
                };
              }
            }
          }

          return false;
        },

        previewForm: function () {
          new FormsFactory().previewForm({
            formId: ctrl.orderForm.id,
            eventName: ctrl.model.name,
            eventStartTime: ctrl.model.startTime,
            eventEndTime: ctrl.model.endTime,
          });
        },

        success: {
          complete: function (response) {
            ctrl.isSubmitted = false;
            ctrl.isSaving = false;

            ctrl.currentEventName = response.data.payload.name;

            $scope.programsInstanceEdit.notice.showSuccessMessages([{ message: 'Successfully Updated!' }]);

            $timeout(function () {
              $scope.programsInstanceEdit.notice.hideSuccessMessages();
            }, 3000);
          },

          getDiscountCodes: function (response) {
            ctrl.discountCodes = response.data.payload.list;
          },

          getEvent: function (response) {
            ctrl.model = response.data.payload;
            ctrl.currentEventName = ctrl.model.name;
            ctrl.startDate = CalendarService.parseDate(ctrl.model.startTime);
            ctrl.endDate = CalendarService.parseDate(ctrl.model.endTime);
            ctrl.formattedLastModified =
              $filter('date')(ctrl.model.lastModified, ctrl.timeStampDateFormat) +
              ' at ' +
              $filter('date')(ctrl.model.lastModified, ctrl.timeStampHourFormat);

            if (ctrl.model.state && ctrl.model.state === 'cancelled') {
              ctrl.isCancelled = true;
              ctrl.formattedCancellationDate =
                $filter('date')(ctrl.model.cancellationDate, ctrl.timeStampDateFormat) +
                ' at ' +
                $filter('date')(ctrl.model.cancellationDate, ctrl.timeStampHourFormat);
            }

            ctrl.model.startDate = $filter('date')(
              ctrl.startDate,
              UserPreferencesService.getDateFormat('extendedDate', 'dateFormat')
            );
            ctrl.model.endDate = $filter('date')(
              ctrl.endDate,
              UserPreferencesService.getDateFormat('extendedDate', 'dateFormat')
            );
            ctrl.model.formattedEndTime = $filter('date')(ctrl.endDate, HelpersService.dateFormats.standardTime);
            ctrl.model.formattedStartTime = $filter('date')(ctrl.startDate, HelpersService.dateFormats.standardTime);
            ctrl.model.priceList = TemplatesService.processSalesChannels(ctrl.model.priceList);

            // Need to remove discount and discountedPrice for equality to work

            for (let i = 0, ii = ctrl.model.priceList.prices.length; i < ii; i++) {
              if (ctrl.model.originalFields) {
                ctrl.model.priceList.prices[i].discountedPrice = null;
                delete ctrl.model.priceList.prices[i].discountedPrice;

                ctrl.model.priceList.prices[i].discount = null;
                delete ctrl.model.priceList.prices[i].discount;
              }
            }

            if (ctrl.model.flexPays instanceof Array) {
              for (let i = 0, ii = ctrl.model.flexPays.length; i < ii; i++) {
                ctrl.model.flexPays[i].endDate = CalendarService.parseDate(ctrl.model.flexPays[i].endTime);
                ctrl.model.flexPays[i].startDate = CalendarService.parseDate(ctrl.model.flexPays[i].startTime);

                ctrl.model.flexPays[i].formattedEndTime = $filter('date')(
                  ctrl.model.flexPays[i].endDate,
                  HelpersService.dateFormats.standardTime
                );
                ctrl.model.flexPays[i].formattedStartTime = $filter('date')(
                  ctrl.model.flexPays[i].startDate,
                  HelpersService.dateFormats.standardTime
                );

                if (
                  ctrl.model.originalFields &&
                  ctrl.model.originalFields.flexPays instanceof Array &&
                  ctrl.model.originalFields.flexPays[i]
                ) {
                  ctrl.model.originalFields.flexPays[i].endDate = ctrl.model.flexPays[i].endDate;
                  ctrl.model.originalFields.flexPays[i].startDate = ctrl.model.flexPays[i].startDate;

                  ctrl.model.originalFields.flexPays[i].formattedEndTime = ctrl.model.flexPays[i].formattedEndTime;
                  ctrl.model.originalFields.flexPays[i].formattedStartTime = ctrl.model.flexPays[i].formattedStartTime;
                }
              }
            }

            ctrl.processCustomFields();

            ctrl.originalPriceList = angular.copy(ctrl.model.priceList);

            ctrl.currentPriceList = angular.copy(ctrl.model.priceList);

            ctrl.originalTicketConfig = angular.copy(ctrl.model.ticketConfig);

            ctrl.currentTicketConfig = angular.copy(ctrl.model.ticketConfig);
            if (ctrl.currentTicketConfig) {
              ctrl.currentTicketConfigId = ctrl.currentTicketConfig.id || '';
            }

            if (ctrl.model.orderForms instanceof Array && ctrl.model.orderForms.length) {
              ctrl.orderForm = angular.copy(ctrl.model.orderForms[0]);
              ctrl.preferences = new FormsFactory().restorePreferences(ctrl.orderForm.preferences);
            }

            if (PrinterData.data && PrinterData.data.success) {
              ctrl.success.getPrinters(PrinterData);
            } else {
              ctrl.error.getPrinters(PrinterData);
            }

            ctrl.relink.setCurrent(ctrl.model);

            ctrl.isSuspended = ctrl.model.state && ctrl.model.state === 'suspended' ? true : false;

            ctrl.getPublishedEventTemplate(ctrl.model.templateId);

            ctrl.processSalesChannels();

            ctrl.isLoaded = true;

            ctrl.updateHeader();
          },

          getPublishedEventTemplate: function (response) {
            if (ctrl.model.originalFields) {
              if (ctrl.model.scheduleId) {
                /*
                 * find the schedule in the previously published template and get the capacity
                 * and ticketConfigs
                 */

                /* defaults */
                ctrl.model.originalFields.capacity = ctrl.model.capacity;
                ctrl.model.originalFields.ticketConfig = angular.copy(ctrl.model.ticketConfig);

                /* copy the name from the previously published template to the original fields */
                if (response.data.payload.name) {
                  ctrl.model.originalFields.name = response.data.payload.name;
                }

                ctrl.model.originalFields.ticketDetails = angular.copy(response.data.payload.ticketDetails);

                if (response.data.payload.schedules) {
                  response.data.payload.schedules.forEach(function (schedule) {
                    if (schedule.hasOwnProperty('id') && ctrl.model.scheduleId == schedule['id']) {
                      /* copy capacity and ticket configs from schedule to original fields */
                      if (schedule.hasOwnProperty('capacity')) {
                        ctrl.model.originalFields.capacity = schedule['capacity'];
                      }
                      if (schedule.hasOwnProperty('ticketConfig')) {
                        ctrl.model.originalFields.ticketConfig = angular.copy(schedule['ticketConfig']);
                      }
                      if (schedule.hasOwnProperty('salesChannels')) {
                        ctrl.model.originalFields.salesChannels = angular.copy(schedule['salesChannels']);
                      }
                    }
                  });
                }
              }
              response.data.payload.originalFields = angular.copy(ctrl.model.originalFields);
            }

            ctrl.relink.setRestore(response.data.payload);

            $scope.$on(
              '$destroy',
              $scope.$watch('programsInstanceEdit.model.name', function (n, o) {
                ctrl.model.fieldStatus['name'].modified = !ctrl.relink.equal('name');
              })
            );

            $scope.$on(
              '$destroy',
              $scope.$watch('programsInstanceEdit.model.description', function (n, o) {
                ctrl.model.fieldStatus['description'].modified = !ctrl.relink.equal('description');
              })
            );

            $scope.$on(
              '$destroy',
              $scope.$watch('programsInstanceEdit.model.emailConfirmationMessage', function (n, o) {
                ctrl.model.fieldStatus['emailConfirmationMessage'].modified =
                  !ctrl.relink.equal('emailConfirmationMessage');
              })
            );

            $scope.$on(
              '$destroy',
              $scope.$watch('programsInstanceEdit.model.emailCancellationMessage', function (n, o) {
                ctrl.model.fieldStatus['emailCancellationMessage'].modified =
                  !ctrl.relink.equal('emailCancellationMessage');
              })
            );

            $scope.$on(
              '$destroy',
              $scope.$watch('programsInstanceEdit.model.capacity', function (n, o) {
                ctrl.model.fieldStatus['capacity'].modified = !ctrl.relink.equal('capacity', true);
              })
            );

            $scope.$on(
              '$destroy',
              $scope.$watch(
                'programsInstanceEdit.model.customFields',
                function (n, o) {
                  ctrl.model.fieldStatus['customFields'].modified = !ctrl.relink.equal('customFields', true);
                },
                true
              )
            );

            $scope.$on(
              '$destroy',
              $scope.$watch('programsInstanceEdit.model.ticketDetails.ticketDurationDays', function (n, o) {
                ctrl.model.fieldStatus['ticketDetails'].modified = !ctrl.relink.equal('ticketDetails', true);
              })
            );

            if (ctrl.hasFlexpays()) {
              const flexPayWatcherFn = function (n, o) {
                ctrl.model.fieldStatus['flexPays'].modified = !ctrl.relink.equal('flexPays', true);
              };
              for (let i = 0, ii = ctrl.model.flexPays.length; i < ii; i++) {
                flexPayWatchers.push(flexPayWatcherFn);
                $scope.$on(
                  '$destroy',
                  $scope.$watchCollection('programsInstanceEdit.model.flexPays[' + i + ']', flexPayWatchers[i])
                );
              }
            }

            ctrl.model.fieldStatus['startTime'].modified = !ctrl.relink.equal('startTime', true);
            ctrl.model.fieldStatus['endTime'].modified = !ctrl.relink.equal('endTime', true);

            ctrl.model.fieldStatus.salesChannels = { modified: false, locked: false };

            $scope.$on(
              '$destroy',
              $scope.$watch(
                'programsInstanceEdit.model.salesChannels',
                function (n, o) {
                  ctrl.model.fieldStatus['salesChannels'].modified = !ctrl.relink.equal('salesChannels', true);
                },
                true
              )
            );
          },

          getPriceLists: function (response) {
            $scope.programsInstanceEdit.priceLists = response.data.payload.list;
            $scope.programsInstanceEdit.setCurrentPriceList();
          },

          getTicketConfigs: function (response) {
            ctrl.ticketConfigs = ctrl.processTicketConfigs(response.data.payload.list);
            // ctrl.setCurrentTicketConfig();
          },

          getPrinters: function (response) {
            ctrl.printers = ctrl.processPrinters(response.data.payload);
            ctrl.printers = ctrl.setPrinterConfig(ctrl.printers);
          },

          getDefaultTicketConfig: function (response) {
            ctrl.tenantTicketConfig = response.data.payload.ticketConfig;
          },

          getAddons: function (response) {
            ctrl.addons = response.data.payload.list;
            console.log('programsInstance::getInventory', ctrl.addons);
          },

          removeEvent: function (response) {
            $state.go('application.programs.calendar.event');
          },

          cancelEvent: function (response) {
            ctrl.formattedCancellationDate =
              $filter('date')(response.data.payload.cancellationDate, ctrl.timeStampDateFormat) +
              ' at ' +
              $filter('date')(response.data.payload.cancellationDate, ctrl.timeStampHourFormat);
            ctrl.isCancelled = true;
          },
        },

        error: {
          complete: function (response) {
            ctrl.isSubmitted = false;
            ctrl.isSaving = false;

            ctrl.notice.showErrorMessages([{ message: response.data.error }]);
          },

          getEvent: function (response) {
            const error = HelpersService.path(
              response,
              ['data', 'error'],
              'An error occurred while retrieving the event.'
            );
            $scope.programsInstanceEdit.notice.showErrorMessages([{ message: error }]);
          },

          getPublishedEventTemplate: function (response) {
            const error = HelpersService.path(
              response,
              ['data', 'error'],
              'An error occurred while retrieving the event.'
            );
            $scope.programsInstanceEdit.notice.showErrorMessages([{ message: error }]);
          },

          getDiscountCodes: function (response) {
            const error = HelpersService.path(
              response,
              ['data', 'error'],
              'An error occurred while retrieving the discount code.'
            );
            $scope.programsInstanceEdit.notice.showErrorMessages([{ message: error }]);
          },

          getPriceLists: function (response) {
            $scope.programsInstanceEdit.notice.showErrorMessages([{ message: response.data.error }]);
          },

          getTicketConfigs: function (response) {
            $scope.programsInstanceEdit.notice.showErrorMessages([{ message: response.data.error }]);
          },

          getPrinters: function (response) {
            const error = HelpersService.path(
              response,
              ['data', 'error'],
              'An error occurred while retrieving the printers.'
            );
            $scope.programsInstanceEdit.notice.showErrorMessages([{ message: error }]);
          },
          getDefaultTicketConfig: function (response) {
            const error = HelpersService.path(
              response,
              ['data', 'error'],
              'An error occurred while retrieving the ticket config.'
            );
            $scope.programsInstanceEdit.notice.showErrorMessages([{ message: error }]);
          },

          getAddons: function (response) {
            $scope.programsInstanceEdit.notice.showErrorMessages([{ message: response.data.error }]);
          },

          removeEvent: function (response) {
            ctrl.isSubmitted = false;

            $scope.programsInstanceEdit.notice.showErrorMessages([{ message: response.data.error }]);
          },

          cancelEvent: function (response) {
            ctrl.isSubmitted = false;

            $scope.programsInstanceEdit.notice.showErrorMessages([{ message: response.data.error }]);
          },
        },

        onPriceListChange: function () {
          ctrl.model.priceList = angular.copy(ctrl.currentPriceList);
          // next tick
          $timeout(function () {
            ctrl.model.fieldStatus['priceList'].modified = !ctrl.relink.equal('priceList', true);
          }, 10);
        },

        onTicketConfigChange: function () {
          ctrl.printers.forEach(function (printer) {
            printer.selection = ctrl.layoutLevels[1].value;
          });
          ctrl.model.ticketConfig = angular.copy(ctrl.currentTicketConfig);
          // next tick
          $timeout(function () {
            ctrl.model.fieldStatus['ticketConfig'].modified = true;
          }, 10);
        },

        onPrinterSelectionChange: function (printer, isEdit) {
          printer.selection = isEdit ? ctrl.layoutLevels[2].value : ctrl.layoutLevels[0].value;
          // next tick
          $timeout(function () {
            ctrl.model.fieldStatus['ticketConfig'].modified = true;
          }, 10);
        },
      };

      $scope.programsInstanceEditGrid = {
        enableRowSelection: false,
        paginate: false,
        showFooter: false,
        multiSelect: false,
      };

      $scope.addOnGridOptions = {
        enableRowSelection: false,
        multiSelect: false,
        paginate: false,
        columnDefs: [
          {
            field: 'id',
            visible: false,
          },
          {
            field: 'order',
            visible: false,
          },
          {
            field: 'name',
            displayName: 'Name',
          },
          {
            field: 'description',
            displayName: 'Description',
          },
          {
            field: 'sku',
            displayName: 'SKU',
          },
          {
            field: 'price',
            displayName: 'Price',
            cellFilter: 'currency',
          },
          {
            field: 'salesChannels[0].enabled',
            displayName: 'Web',
            type: 'boolean',
            cellTemplate: `<div data-ng-class="\'colt\' + col.index"><label><input type="checkbox" class="grid-input" data-ng-model="MODEL_COL_FIELD" /><span class="sr-only">Web</span></label></div>`,
          },
          {
            field: 'salesChannels[1].enabled',
            displayName: 'POS',
            type: 'boolean',
            cellTemplate: `<div data-ng-class="\'colt\' + col.index"><label><input type="checkbox" class="grid-input" data-ng-model="MODEL_COL_FIELD" /><span class="sr-only">POS</span></label></div>`,
          },
          {
            field: 'salesChannels[2].enabled',
            displayName: 'Reseller',
            type: 'boolean',
            cellTemplate: `<div data-ng-class="\'colt\' + col.index"><label><input type="checkbox" class="grid-input" data-ng-model="MODEL_COL_FIELD" /><span class="sr-only">Reseller</span></label></div>`,
          },
          {
            field: 'salesChannels[3].enabled',
            displayName: 'Customer Rep.',
            type: 'boolean',
            cellTemplate: `<div data-ng-class="\'colt\' + col.index"><label><input type="checkbox" class="grid-input" data-ng-model="MODEL_COL_FIELD" /><span class="sr-only">Customer Rep.</span></label></div>`,
          },
          {
            field: 'salesChannels[5].enabled',
            displayName: 'Kiosk',
            type: 'boolean',
            cellTemplate: `<div data-ng-class="\'colt\' + col.index"><label><input type="checkbox" class="grid-input" data-ng-model="MODEL_COL_FIELD" /><span class="sr-only">Kiosk</span></label></div>`,
          },
          {
            field: 'actions',
            displayName: 'Actions',
            onCellNavClick: function (row, col) {
              $scope.programsInstanceEdit.removeInventory(row.entity.id);
            },
            cellTemplate: `<div class="ui-grid-cell-contents" ng-class="col.colIndex()"><a class="clickable" data-ng-click="grid.appScope.remove(row.entity.id)">Remove<span class="sr-only">-Opens a dialog</span></a></div>`,
          },
        ],
      };

      $scope.programsInstanceEdit = ctrl;

      ctrl.init();
    },
  ]).name;
